import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
<footer className="bg-gray-900 text-white py-10 px-6 border-t border-white/20 shadow-[0_-1px_8px_rgba(255,255,255,0.1)]">

      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start gap-8">
        
        {/* Logo + Açıklama + İletişim */}
        <div className="max-w-sm">
          <h2 className="text-xl text-green-400 mb-2 font-righteous md:whitespace-nowrap">Ayvalık Marin Boat ve Yatcılık Sanayi Tic. Ltd. Şti.</h2>
          <p className="text-gray-400 text-sm mb-4">
            Ayvalık Marin, kaliteli tekne üretimiyle denizcilik tutkunlarına eşsiz bir deneyim sunar.
          </p>
          <p className="text-gray-400 text-sm">
            <strong>Adres:</strong> 150 Evler Mah. 29 Mayıs Cad. NO:226 AYVALIK/BALIKESİR
          </p>
          <p className="text-gray-400 text-sm">
            <strong>Telefon:</strong> 0 266 331 0 444
          </p>
          <p className="text-gray-400 text-sm">
            <strong>Mail:</strong> info@ayvalikmarin.com.tr
          </p>
        </div>

        {/* Menü Linkleri */}
        <div className="flex flex-col gap-2">
          <h3 className="text-lg font-semibold mb-1">Menü</h3>
          <Link to="/" className="text-gray-400 hover:text-green-400 transition">Anasayfa</Link>
          <Link to="/urunler/tekne-ve-yatlar" className="text-gray-400 hover:text-green-400 transition">Tekne Ve Yatlar</Link>
          <Link to="/urunler/motorlar" className="text-gray-400 hover:text-green-400 transition">Motorlar</Link>
          <Link to="/urunler/aksesuarlar" className="text-gray-400 hover:text-green-400 transition">Aksesuarlar</Link>
          <Link to="/urunler/sanalcapa" className="text-gray-400 hover:text-green-400 transition">Elektrikli Motor & Sanal Çapa</Link>


        </div>

        {/* Sosyal Medya */}
        <div className="flex flex-col gap-2">
          <h3 className="text-lg font-semibold mb-1">Bizi Takip Edin</h3>
          <a
            href="https://wa.me/905326036152"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-green-400 transition"
          >
            WhatsApp
          </a>
          <a
            href="https://instagram.com/ayvalikmarin"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-pink-400 transition"
          >
            Instagram
          </a>

                    <a
            href="https://facebook.com/ayvalikmarin"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-pink-400 transition"
          >
            Facebook
          </a>

        </div>
      </div>

      {/* Alt Bilgi */}
      <div className="mt-8 text-center text-gray-500 text-sm t border-gray-700 pt-4">
        © {new Date().getFullYear()} <span className="font-righteous">Ayvalık Marin</span>. Tüm hakları saklıdır.
      </div>
      
    </footer>
  );
};

export default Footer;
